import React from 'react'
import { useDispatch } from 'react-redux'
import { addModal } from 'features/modals/modalSlice'
import { showNotification } from 'features/notifications'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
import { _, captureError } from 'utils'
import ConfirmModal from 'components/ConfirmModal'

interface ModalOptions {
    title?: string
    description?: string
}

const useDeleteItem = (deleteFn, callback?: (e?: any) => void, modalOptions?: ModalOptions) => {
    const dispatch = useDispatch()
    const handleDelete = async (id) => {
        try {
            const response = await deleteFn(id)
            if (response?.data) {
                dispatch(showNotification({
                    type: 'success',
                    body: _('form.notification.delete_success')
                }))
                callback?.(id) // Re-call get list to get new data after deleting a item
            } else {
                dispatch(showErrorNotification(response?.errors))
            }
        } catch (err) {
            captureError(err)
        }
    }
    const showDeleteConfirmModal = (id?: any, onDeleteSuccess?: () => void) => {
        const handleDeleteItem = async () => {
            await handleDelete(id)
            onDeleteSuccess?.()
        }
        dispatch(addModal({
            Component: ({ close }: { close: () => void }) => (
                <ConfirmModal
                    close={close}
                    title={modalOptions?.title || _('delete_confirm.title')}
                    confirmDescription={modalOptions?.description || _('delete_confirm.description')}
                    confirmText={_('delete_confirm.confirm_button')}
                    onConfirm={handleDeleteItem}
                />
            ),
            shouldNotWrap: true
        }))
    }

    return { showDeleteConfirmModal, handleDelete }
}

export default useDeleteItem
